interface NavigationProps {
  scrolled: boolean;
}

export default function Navigation({ scrolled }: NavigationProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-8 py-6 flex items-center justify-between">
        <div className="flex items-center gap-4">
          <img 
            src="https://public.readdy.ai/ai/img_res/e4458280-b7a8-4f26-a9e2-57aa89727e49.png" 
            alt="NOLIOT Logo" 
            className="h-10 w-10 object-contain"
          />
          <div className={`text-2xl font-medium transition-colors ${scrolled ? 'text-gray-900' : 'text-white'}`}>
            NOLIOT d. o. o.
          </div>
        </div>
        <div className="flex items-center gap-8">
          <button
            onClick={() => scrollToSection('home')}
            className={`text-sm font-medium transition-colors hover:opacity-80 cursor-pointer whitespace-nowrap ${
              scrolled ? 'text-gray-900' : 'text-white'
            }`}
          >
            Home
          </button>
          <button
            onClick={() => scrollToSection('about')}
            className={`text-sm font-medium transition-colors hover:opacity-80 cursor-pointer whitespace-nowrap ${
              scrolled ? 'text-gray-900' : 'text-white'
            }`}
          >
            About
          </button>
          <button
            onClick={() => scrollToSection('products')}
            className={`text-sm font-medium transition-colors hover:opacity-80 cursor-pointer whitespace-nowrap ${
              scrolled ? 'text-gray-900' : 'text-white'
            }`}
          >
            Products
          </button>
          <button
            onClick={() => scrollToSection('features')}
            className={`text-sm font-medium transition-colors hover:opacity-80 cursor-pointer whitespace-nowrap ${
              scrolled ? 'text-gray-900' : 'text-white'
            }`}
          >
            Features
          </button>
          <button
            onClick={() => scrollToSection('contact')}
            className={`text-sm font-medium transition-colors hover:opacity-80 cursor-pointer whitespace-nowrap ${
              scrolled ? 'text-gray-900' : 'text-white'
            }`}
          >
            Contact
          </button>
        </div>
      </div>
    </nav>
  );
}
